import '../styles/globals.css'
import type { AppProps } from 'next/app'
// import { createBrowserSupabaseClient } from '@supabase/auth-helpers-nextjs'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import { Toaster } from 'react-hot-toast'
import { supabaseClient } from '../common/supabase'
import { NextPage } from 'next'
import { ReactElement, ReactNode } from 'react'
import { Analytics } from '@vercel/analytics/react'

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

export default function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  // Create a new supabase browser client on every first render.
  // const [supabaseClient] = useState(() => createBrowserSupabaseClient())
  const getLayout = Component.getLayout ?? ((page) => page)

  return (
    <SessionContextProvider
      // @ts-ignore
      supabaseClient={supabaseClient}
      initialSession={pageProps.initialSession}
    >
      <Toaster />
      {getLayout(<Component {...pageProps} />)}
      <Analytics />
    </SessionContextProvider>
  )
}
